const locale = {
	TITLE: "Strategy - Spanish",
};

export default locale;
